import { types } from 'mobx-state-tree';
import { withSetPropAction } from './helpers/withSetPropAction';
import {
  CartData,
  SubtotalInfo,
  ProductItemInfo,
  FreightBasicInfo,
  AddCartStatusInfo,
} from '@/apis/cart/cart.interface';

export const CartStoreModel = types
  .model('CartStore')
  .props({
    productList: types.frozen([]), // 再次购买商品信息
    productItems: types.frozen<{ info: ProductItemInfo }[] | null>(null),
    productSkuIds: types.maybe(types.string), // 逗号分隔的字符串skuid
    cartData: types.frozen<CartData | null>(null), // 购物车数据
    isLoaded: types.optional(types.boolean, false), // 是否加载完成
    isShowProdectModal: types.optional(types.boolean, false), // 是否显示商品详情弹窗
    isTypeLoaded: types.optional(types.boolean, false), // 是否加载完成
    dialogStyle: types.frozen<Partial<CSSStyleDeclaration>>({
      background: 'transparent',
      boxShadow: 'none',
    }), // 商品详情弹窗样式
    cartSkuId: types.maybe(types.string), // 购物车商品skuId
    isNotLogin: types.optional(types.boolean, true), // 是否未登录
    isError: types.optional(types.boolean, false), // 是否有错误
    isAddCartFailed: types.optional(types.boolean, false), // 部分加车失败
    failedProductItems: types.maybe(types.string), // 失败商品列表
    addCartCode: types.maybe(types.string), // 加车接口返回code
    shipmentType: types.maybe(types.string), // 配送方式 1 配置 2 自提
    freight: types.frozen<{ info: FreightBasicInfo } | null>(null), // 包邮信息
    subtotal: types.frozen<{ info: SubtotalInfo } | null>(null), // 商品总量信息
    curDeleteProValue: types.frozen<{ skuId: string; num: number } | null>(null), // 当前删除商品信息
    isShowSnackbar: types.optional(types.boolean, false), // 是否显示过礼物通知
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    setCartList(productList: any) {
      self.productList = productList;
    },
    setProductItems(info: { info: ProductItemInfo }[] | null) {
      self.productItems = info;
    },
    setProductSkuIds(productSkuIds: string) {
      self.productSkuIds = productSkuIds;
    },
    setCartData(cartData: CartData | null) {
      self.cartData = cartData;
      // if (!cartData || !cartData.data) {
      //   return;
      // }
      // // 商品列表楼层
      // const hierarchyRoot = cartData.hierarchy.root || [];
      // const productItems: { info: ProductItemInfo }[] = [];
      // const productSkuIds: string[] = [];

      // function processHierarchyKey(key: string) {
      //   if (!cartData) {
      //     return;
      //   }
      //   const item = cartData.data[key];
      //   if (item && "type" in item && item.type) {
      //     const namespace = item.type.namespace;
      //     if (
      //       namespace === "core.trade-DM#cartView.product-M#productItem" ||
      //       namespace === "core.trade-DM#cartView.unusableProduct-M#defaultUnusableProductItem"
      //     ) {
      //       productItems.push(item as { info: ProductItemInfo });
      //       if (namespace === "core.trade-DM#cartView.product-M#productItem") {
      //         productSkuIds.push(
      //           (item as { info: ProductItemInfo })?.info?.["C-M#productItem&core"]?.skuId || "",
      //         );
      //       }
      //     }
      //   }
      //   const subKeys = cartData.hierarchy[key] || [];
      //   subKeys.forEach(processHierarchyKey);
      // }
      // hierarchyRoot.forEach(processHierarchyKey);
      // self.productItems = productItems;
      // if (productSkuIds.length > 0) {
      //   const firstTenItems = productSkuIds.slice(0, Math.min(productSkuIds.length, 10));
      //   self.productSkuIds = firstTenItems.join(",");
      // }
      // // 商品总量信息楼层
      // const subTotals = Object.values(cartData.data).filter((item) => {
      //   if (
      //     "type" in item &&
      //     item.type &&
      //     item.type.namespace === "core.trade-DM#cartView.subtotal-M#defaultSubtotalItem"
      //   ) {
      //     return true;
      //   }
      //   return false;
      // }) as Array<{ info: SubtotalInfo }>;
      // if (subTotals && subTotals.length > 0) {
      //   self.subtotal = subTotals["0"];
      // }
      // // 商品包邮信息楼层
      // const freeShip = Object.values(cartData.data).filter((item) => {
      //   if (
      //     "type" in item &&
      //     item.type &&
      //     item.type.namespace === "jd_main-DM#cartView.freight-M#basic"
      //   ) {
      //     return true;
      //   }
      //   return false;
      // }) as Array<{ info: FreightBasicInfo }>;
      // if (freeShip && freeShip.length > 0) {
      //   self.freight = freeShip["0"];
      // }
      // // 商品加车失败楼层
      // const addCartFailed = Object.values(cartData.data).filter((item) => {
      //   if ("type" in item && item.type && item.type.namespace === "jd_main-DM#cartView.addCartCheckResult-M#basic") {
      //     return true;
      //   }
      //   return false;
      // }) as Array<{ info: AddCartStatusInfo }>;
      // if (addCartFailed && addCartFailed.length > 0) {
      //   self.isAddCartFailed = true;
      //   const failedItems = addCartFailed["0"].info?.["HJM-M#basic&basic"]?.checkNoStockSkuList;
      //   if (failedItems) {
      //     self.failedProductItems = failedItems;
      //   }
      // }
      // // TODO 暂时写死
      // self.cartFullfillmentType = "1";
      // self.isLoaded = true;
    },
    setIsLoaded(isLoaded: boolean) {
      self.isLoaded = isLoaded;
    },
    setIsShowProdectModal(isShowProdectModal: boolean) {
      self.isShowProdectModal = isShowProdectModal;
    },
    setIsTypeLoaded(isTypeLoaded: boolean) {
      self.isTypeLoaded = isTypeLoaded;
      if (isTypeLoaded) {
        self.dialogStyle = {
          background: '#fff',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        };
      } else {
        self.dialogStyle = {
          background: 'transparent',
          boxShadow: 'none',
        };
      }
    },
    setDialogStyle(dialogStyle: { background: string; boxShadow: string }) {
      self.dialogStyle = dialogStyle;
    },
    setCartSkuId(cartSkuId: string) {
      self.cartSkuId = cartSkuId;
    },
    setIsNotLogin(isNotLogin: boolean) {
      self.isNotLogin = isNotLogin;
    },
    setIsError(isError: boolean) {
      self.isError = isError;
    },
    setIsAddCartFailed(isAddCartFailed: boolean) {
      self.isAddCartFailed = isAddCartFailed;
    },
    setFailedProductItems(failedProductItems: string) {
      self.failedProductItems = failedProductItems;
    },
    setAddCartCode(addCartCode: string) {
      self.addCartCode = addCartCode;
    },
    setShipmentType(shipmentType: string) {
      self.shipmentType = shipmentType;
    },
    setCurDeleteProValue(curDeleteProValue: { skuId: string; num: number } | null) {
      self.curDeleteProValue = curDeleteProValue;
    },
    setIsShowSnackbar(isShowSnackbar: boolean) {
      self.isShowSnackbar = isShowSnackbar;
    },
  }));
